import React, { useEffect, useState, useRef } from "react";
import { styleMarkup, slugify, splitMessage } from "helpers"
import sizes from "sizes"
import DownloadGraphic from "./download-graphic"

import "./graphic.scss"

const pad = 40
const fontWeight = 700

const EditableGraphic = ({svg, state, dispatch, fontFamily, layout, graphicType}) => {
  const [svgText,setSvgText] = useState()
  const [defaultSvgMarkup,setDefaultSvgMarkup] = useState()
  const {backgroundColor, textColor, accentColor} = state.color ? state.color : {}

  let id = slugify(svg.title)

  // TODO remove...
  let url = svg.url.replace("localhost:3000", "toolkit.powerthepolls.org")

  useEffect(() => {
    fetch(url)
      .then(r=>r.text())
      .then(text => {
        setSvgText(text);
      })
  },[url])

  let markup = svgText ? styleMarkup(svgText,id,textColor,accentColor,backgroundColor) : null

  useEffect(() => {
    if (state.image) {
      let svgurl = state.image[0] ? state.image[0].url.replace("localhost:3000", "toolkit.powerthepolls.org") : state.image.url

      if (state.image[0] && state.image[0].mimeType === "image/svg+xml") {
        fetch(svgurl)
          .then(r=>r.text())
          .then(text => {
            setDefaultSvgMarkup(text);
          })
      }
    } else {
      setDefaultSvgMarkup(null)
    }
  },[state.image,state.color])

  let statemarkup = defaultSvgMarkup ? styleMarkup(defaultSvgMarkup,`placeholder_${id}`,textColor,accentColor,backgroundColor) : null
  let defaultImg = state.image && state.image[0] ? state.image[0] : null

  return <div className="graphic">
    <Canvas
      fontFamily={graphicType === "logoGraphic" ? "Oswald" : fontFamily}
      message={state.message}
      color={state.color}
      editDispatch={dispatch}
      size={state.size}
      svgs={svg}
      markup={markup}
      defaultImg={statemarkup ? statemarkup : defaultImg}
      uploadedImage={state.upload}
      layout={layout}
    />

    <DownloadGraphic
      downloadUrl={state.download}
      title={svg.title}
    />
  </div>
}

export const Canvas = ({
  color,
  editDispatch,
  fontFamily,
  imageSrc,
  layout,
  markup,
  message,
  size,
  svgs,
  uploadedImage,
  defaultImg
}) => {
  const ref = useRef()
  const [image,setImage] = useState()
  const [partnerSvg,setPartnerSvg] = useState()

  // uploaded graphic from CMS
  useEffect(() => {
    const newImage = new Image()
    const onLoad = () => {
      setImage(newImage)
    }

    newImage.addEventListener("load",onLoad);
    newImage.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(markup)));

    return () => {
      newImage.removeEventListener("load",onLoad);
    }
  },[size,markup])


  // Placeholder image...
  useEffect(() => {
    if (defaultImg) {
      const newImage = new Image()
      const onLoad = () => {
        setPartnerSvg(newImage)
      }

      newImage.addEventListener("load",onLoad);

      if (typeof defaultImg === "string") {
        newImage.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(defaultImg)));
      } else {
        newImage.setAttribute("crossorigin", "anonymous");
        newImage.src = defaultImg.url.replace("localhost:3000", "toolkit.powerthepolls.org")
      }

    }
  },[defaultImg,uploadedImage,color])

  // uploaded graphic from user
  useEffect(() => {
    let partnerMarkup

    if (uploadedImage && uploadedImage[0]) {
      let partnerimg = uploadedImage[0]

      if (partnerimg.file.type === "image/svg+xml") {
        let base64url = partnerimg.dataURL.split("base64,")
        let res = atob(base64url[1])
        partnerMarkup = styleMarkup(res,partnerimg.file.name,color.textColor,color.accentColor,color.backgroundColor)
      } else {
        setPartnerSvg(null)
      }
    }

    const newImage = new Image()
    const onLoad = () => {
      setPartnerSvg(newImage)
    }

    newImage.addEventListener("load",onLoad);
    newImage.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(partnerMarkup)));

    return () => {
      newImage.removeEventListener("load",onLoad);
    }
  }, [uploadedImage,color,defaultImg])


  useEffect(() => {
    if (ref.current && image) {
      const draw = async () => {

        const metrics = sizes[size]

        const [width,height] = metrics.size;
        const scale = Math.min(width / image.width, height / image.height)
        let imageW = (image.width * scale)
        let imageH = (image.height * scale)
        const center = width / 2 - imageW / 2
        const [textW,textH] = metrics[layout].text.size
        let imageX,imageY,textX,textY

        switch(layout) {
          case "copyBottom":
            imageX = center
            imageY = 0;
            textX = center + metrics[layout].text.xOffset
            textY = (height/1.333) + metrics[layout].text.yOffset
            break;

          case "copyTop":
            imageX = center
            imageY = height - imageH;
            textX = center + metrics[layout].text.xOffset
            textY = 0
            break;

          case "default":
            imageW = imageW / 2
            imageH = imageH / 2
            imageX = (width / 2) - pad
            imageY = height / 2 - imageH / 2

            if(!uploadedImage) {
              textX = pad*2
              textY = height / 3.15
            }

            break;

          case "endorsement":
            imageX = center
            imageY = (height / 2 - imageH / 2) + pad*2
            textX = (width / 2) - pad
            textY = pad*4
            break;

          case "imageAndCopy":
            imageX = center
            imageY = 0

            textX = center + metrics[layout].text.xOffset
            textY = (height/2) + pad
            break;

          default:
            break;
        }

        const padding = width*.04
        const ctx = setupCanvas(ref.current,width,height)

        ctx.fillStyle = color.backgroundColor
        ctx.rect(0,0,width,height)
        ctx.fill()

        ctx.drawImage(image,imageX,imageY,imageW,imageH)

        if (layout === "imageAndCopy" && partnerSvg) {
          if (size === "instagram") {
            drawImageProp(ctx, partnerSvg, pad, pad, width - (pad*2), height / 2)
          } else {
            drawImageProp(ctx, partnerSvg, 200 + (pad*2), pad, 800 - (pad*4), height / 2)
          }
        }

        // LOGO UPLOAD
        if (uploadedImage && uploadedImage[0] && layout !== "endorsement") {
          const partnerLogo = await getImage(uploadedImage[0].dataURL)

          let scale = Math.min(width / partnerLogo.width, height / partnerLogo.height)
          let partnerW = (partnerLogo.width * scale) / 2.5
          let partnerH = (partnerLogo.height * scale) / 2.5
          let partnerX = metrics[layout].upload.pos[0]
          let partnerY = (height / 2) - (partnerH / 2)

          if (layout === "imageAndCopy") {
            if (size === "instagram") {
              drawImageProp(ctx, partnerLogo, pad, pad, width - (pad*2), height / 2)
            } else {
              drawImageProp(ctx, partnerLogo, 200 + (pad*2), pad, 800 - (pad*4), height / 2)
            }

          } else {
            ctx.drawImage(
              partnerSvg ? partnerSvg : partnerLogo,
              partnerX,
              partnerY,
              partnerW,
              partnerH
            )
          }
        }

        // MANUAL TEXT INPUT
        if (message && message.text)  {
          const messageSplit = splitMessage(message.text)
          const messageIsPlaceholder = !!messageSplit

          const displayMessage = messageIsPlaceholder
            ? messageSplit[1] + (new Array(8).fill("_").join("")) + messageSplit[3]
            : message.text;

          let fontSize = maxFontSize(
            ctx,
            displayMessage,
            (textW - 2*padding),
            (textH - 2*padding),
            size => `${fontWeight} ${size}px ${fontFamily}`
          )

          do {
            fontSize--
            ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}`
          } while (measureTextHeight(
            ctx,
            displayMessage,
            (textW - 2*padding),
            fontSize*1.2
          ) > (textH - 3*padding))

          ctx.fillStyle = color.textColor
          ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}`
          wrapText(
            ctx,
            displayMessage,
            (textX + padding),
            (textY + (fontSize + padding)),
            (textW - 2*padding),
            fontFamily === "Oswald" ? fontSize : fontSize*1.2,
            layout === "endorsement" ? "center" : "left"
          )
        }

        if (editDispatch) {
          editDispatch({
            type: "setDownload",
            value: ref.current.toDataURL('image/jpeg', 1.0)
          })
        }
      }
      draw()
    }
  },[ref,image,message,color,size,editDispatch,layout,uploadedImage,fontFamily,partnerSvg,defaultImg])

  return <div className="Canvas">
    <canvas ref={ref} />
  </div>
}

const setupCanvas = (canvas,width,height) => {
  const dpr = window.devicePixelRatio || 1;
  canvas.width = width * dpr;
  canvas.height = height * dpr;

  const ctx = canvas.getContext('2d');
  ctx.scale(dpr, dpr);

  return ctx
}

const wrapText = (context, text, x, y, maxWidth, lineHeight, textAlign="left") => {
  var words = text.split(' '),
    line = '',
    i,
    test,
    metrics;

  for (i = 0; i < words.length; i++) {
    test = words[i];
    metrics = context.measureText(test);
    while (metrics.width > maxWidth) {
      // Determine how much of the word will fit
      test = test.substring(0, test.length - 1);
      metrics = context.measureText(test);
    }
    if (words[i] !== test) {
      words.splice(i + 1, 0,  words[i].substr(test.length))
      words[i] = test;
    }

    test = line + words[i] + ' ';
    metrics = context.measureText(test);

    if (metrics.width > maxWidth && i > 0) {
      context.fillText(line, x, y);
      line = words[i] + ' ';
      y += lineHeight;
      // lineCount++;
    }
    else {
      line = test;
    }
  }

  context.textAlign = textAlign
  context.fillText(line, x, y);
}

const drawImageProp = (ctx, img, x, y, w, h, offsetX, offsetY) => {
  // default offset is center
  offsetX = typeof offsetX === "number" ? offsetX : 0.5;
  offsetY = typeof offsetY === "number" ? offsetY : 0.5;

  // keep bounds [0.0, 1.0]
  if (offsetX < 0) offsetX = 0;
  if (offsetY < 0) offsetY = 0;
  if (offsetX > 1) offsetX = 1;
  if (offsetY > 1) offsetY = 1;

  var iw = img.width,
      ih = img.height,
      r = Math.min(w / iw, h / ih),
      nw = iw * r,   // new prop. width
      nh = ih * r,   // new prop. height
      cx, cy, cw, ch, ar = 1;

  // decide which gap to fill
  if (nw < w) ar = w / nw;
  if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh;  // updated
  nw *= ar;
  nh *= ar;

  // calc source rectangle
  cw = iw / (nw / w);
  ch = ih / (nh / h);

  cx = (iw - cw) * offsetX;
  cy = (ih - ch) * offsetY;

  // make sure source rectangle is valid
  if (cx < 0) cx = 0;
  if (cy < 0) cy = 0;
  if (cw > iw) cw = iw;
  if (ch > ih) ch = ih;

  // fill image in dest. rectangle
  ctx.drawImage(img, cx, cy, cw, ch,  x, y, w, h);
}

const measureTextHeight = (context, text, maxWidth, lineHeight) => {
  let y = 0
  var words = text.split(' '),
    line = '',
    i,
    test,
    metrics;

  for (i = 0; i < words.length; i++) {
    test = words[i];
    metrics = context.measureText(test);
    while (metrics.width > maxWidth) {
      // Determine how much of the word will fit
      test = test.substring(0, test.length - 1);
      metrics = context.measureText(test);
    }
    if (words[i] !== test) {
      words.splice(i + 1, 0,  words[i].substr(test.length))
      words[i] = test;
    }

    test = line + words[i] + ' ';
    metrics = context.measureText(test);

    if (metrics.width > maxWidth && i > 0) {
      line = words[i] + ' ';
      y += lineHeight;
      // lineCount++;
    }
    else {
      line = test;
    }
  }

  return y + lineHeight
}

const maxFontSize = (context, text, maxWidth, maxHeight, setFontSize) => {
  const longestWord = text.split(" ").sort((a,b) => b.length - a.length)[0]
  let size = maxHeight
  do {
    size--
    context.font = setFontSize(size)
  } while(context.measureText(longestWord).width > maxWidth)

  return size
}


// const Logo = (fill="#fff") => `<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 785"><defs></defs><polygon fill="currentColor" points="302.93 103.84 301.97 103.84 274.45 2.86 230.42 2.86 277.8 153.61 325.18 153.61 372.56 2.86 330.68 2.86 302.93 103.84"/><path fill="currentColor" d="M500.33,156.49c38.77,0,67.72-31.83,67.72-78.25S539.1,0,500.33,0s-67.71,31.83-67.71,78.24S461.57,156.49,500.33,156.49Zm0-120.6c16.28,0,26.57,16.75,26.57,42.35s-10.29,42.36-26.57,42.36-26.56-16.75-26.56-42.36S484.06,35.89,500.33,35.89Z"/><polygon fill="currentColor" points="633.14 38.76 678.6 38.76 678.6 153.62 719.04 153.62 719.04 38.76 765.22 38.76 765.22 2.87 633.14 2.87 633.14 38.76"/><polygon fill="currentColor" points="958.44 119.16 880.92 119.16 880.92 94.04 934.04 94.04 934.04 60.06 880.92 60.06 880.92 37.33 956.29 37.33 956.29 2.87 840.96 2.87 840.96 153.62 958.44 153.62 958.44 119.16"/><polygon fill="currentColor" points="163.06 328.54 85.54 328.54 85.54 303.42 138.66 303.42 138.66 269.44 85.54 269.44 85.54 246.71 160.91 246.71 160.91 212.25 45.58 212.25 45.58 363 163.06 363 163.06 328.54"/><path fill="currentColor" d="M276.6,212.25,230.42,363H269.9L278,333.8h44.75l8.13,29.2h41.64L326.37,212.25Zm10,91.16,13.4-47.85h1l13.4,47.85Z"/><path fill="currentColor" d="M526.53,293.12c22.5-.95,41.16-15.79,41.16-35.65,0-27.75-19.38-45.22-58.15-45.22H438.48V363h40V307.72h18.42c13.64,0,20.82,9.09,22.26,26.32,1.19,13.64,2.87,23.45,5.5,29h46.66v-1.68c-5-5.5-9.57-12.92-13.88-35.17C554.05,308.44,542.09,296.72,526.53,293.12Zm-24.16-16.27H478.44V244.79h23.93c17,0,25.6,5.27,25.6,16S519.36,276.85,502.37,276.85Z"/><polygon fill="currentColor" points="642.12 212.25 642.12 363 756.97 363 756.97 327.1 682.79 327.1 682.79 212.25 642.12 212.25"/><polygon fill="currentColor" points="899.7 265.85 872.9 212.25 827.67 212.25 878.4 305.33 878.4 363 917.88 363 917.88 305.33 968.37 212.25 926.02 212.25 899.7 265.85"/><path fill="currentColor" d="M91.27,421.63H41.74V572.37H91.27c45.22,0,76.09-28.23,76.09-75.37S136.49,421.63,91.27,421.63ZM88.4,540.31h-6V453.69h6c21.53,0,37.09,15.79,37.09,43.07C125.49,524.52,109.93,540.31,88.4,540.31Z"/><path fill="currentColor" d="M276.6,421.63,230.42,572.37H269.9L278,543.18h44.75l8.13,29.19h41.64L326.37,421.63Zm10,91.16,13.4-47.85h1l13.4,47.85Z"/><polygon fill="currentColor" points="502.01 475.23 475.21 421.63 429.99 421.63 480.71 514.71 480.71 572.37 520.19 572.37 520.19 514.71 570.68 421.63 528.33 421.63 502.01 475.23"/><path fill="currentColor" d="M321,733.66c24.17-18.67,37.57-30.87,37.57-56.95,0-28-20.82-48.58-57.43-48.58-34.7,0-58.62,21.06-58.62,53.36a73.67,73.67,0,0,0,1.91,14.12l39.72,1.2a39.75,39.75,0,0,1-1.67-12.45c0-12.2,4.78-21.77,17.23-21.77,12,0,16.27,7.18,16.27,16.51,0,14.36-7.66,22.25-30.63,40.68L243.7,752.56v29.19H360.47V748H302.33Z"/><path fill="currentColor" d="M500.33,628.13c-41.15,0-64.6,28.24-64.6,78.25s23.45,78.24,64.6,78.24c41.4,0,64.61-28.23,64.61-78.24S541.73,628.13,500.33,628.13Zm0,123.71c-17.22,0-21.53-14.36-21.53-45.46s4.31-45.47,21.53-45.47c17.47,0,21.78,14.36,21.78,45.47S517.8,751.84,500.33,751.84Z"/><path fill="currentColor" d="M718.68,733.66c24.17-18.67,37.57-30.87,37.57-56.95,0-28-20.82-48.58-57.43-48.58-34.7,0-58.62,21.06-58.62,53.36a73.67,73.67,0,0,0,1.91,14.12l39.72,1.2a40,40,0,0,1-1.67-12.45c0-12.2,4.78-21.77,17.23-21.77,12,0,16.27,7.18,16.27,16.51,0,14.36-7.66,22.25-30.63,40.68l-41.64,32.78v29.19H758.16V748H700Z"/><path fill="currentColor" d="M898,628.13c-41.15,0-64.6,28.24-64.6,78.25s23.45,78.24,64.6,78.24c41.4,0,64.61-28.23,64.61-78.24S939.42,628.13,898,628.13Zm0,123.71c-17.22,0-21.53-14.36-21.53-45.46s4.31-45.47,21.53-45.47c17.47,0,21.78,14.36,21.78,45.47S915.49,751.84,898,751.84Z"/><rect fill="currentColor" x="198.54" y="2.86" width="7.05" height="778.89"/><rect fill="currentColor" x="-0.31" y="2.86" width="7.05" height="778.89"/><rect fill="currentColor" x="397.38" y="2.86" width="7.05" height="778.89"/><rect fill="currentColor" x="596.23" y="2.86" width="7.06" height="778.89"/><rect fill="currentColor" x="795.07" y="2.86" width="7.05" height="778.89"/><rect fill="currentColor" x="993.92" y="2.86" width="7.05" height="778.89"/></svg>`

// function getLogo(fill) {
//   return new Promise((resolve,reject) => {
//     const LogoBlob = new Blob([Logo(fill)], {type: 'image/svg+xml'});
//     const LogoURL = URL.createObjectURL(LogoBlob);

//     const logo = new Image()
//     logo.onload = () => {
//       resolve(logo)
//     }
//     logo.src = LogoURL
//   })
// }

function getImage(src) {
  return new Promise((resolve,reject) => {
    const image = new Image()
    image.onload = () => {
      resolve(image)
    }
    image.src = src
  })
}

export default EditableGraphic
